/**
 * Provides a UI for modifying "public" permissions - those permissions which do not apply to specific entities.
 * @module app/views/admin/permissions/Index
 */
import Backbone from "backbone";
import Editor from "app/views/admin/permissions/Editor";
import FormInputView from "core/views/FormInputView";
import Field from "core/models/Field";
export default Backbone.View.extend({
  className: "permissions-index",
  /**
   * Initializes the interface.
   * @param  {object} options The options hash.
   * @param {GroupCollection} options.collection A set of `Group` models to place in the group selector.
   */
  initialize: function (options) {
    this.options = options;

    this.collection = this.options.collection;
  },

  render: function () {
    var typeSelector = {
      type: "",
    };
    var viewArgs = {
      groups: this.collection.models,
      actions: {
        read: "Global read permission",
        update: "Global write permission",
        create: "Global creation permission",
        delete: "Global delete permission",
      },
      allowAllUsers: true,
      allowPublic: true,
    };

    var view = new Editor(viewArgs);
    var formInputView = new FormInputView({
      model: typeSelector,
      field: new Field({
        id: "type",
        name: "type",
        label: "Permission Type",
        values: [
          {
            value: "",
            text: "Global",
          },
          {
            value: "DataType",
            text: "Layer",
          },
          {
            value: "MapService",
            text: "Map Service",
          },
          {
            value: "Group",
            text: "Group",
          },
          {
            value: "LayerConfiguration",
            text: "Layout",
          },
          {
            value: "Application",
            text: "Plugin",
          },
        ],
      }),
    });

    formInputView.on(
      "change",
      function (value) {
        if (value) {
          viewArgs.type = value;
        } else {
          delete viewArgs.type;
        }

        var oldView = view;

        view = new Editor(viewArgs);
        view.render();
        view.group = oldView.group;
        oldView.$el.replaceWith(view.$el);
      },
      this
    );

    formInputView.render();
    view.render();

    formInputView.$el.appendTo(this.$el);
    view.$el.appendTo(this.$el);
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/admin/permissions/Index.js
// module id = 917
// module chunks = 1